'use strict';

yesNoFilter.$inject = ["gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.yesNoFilter = yesNoFilter;
/*@ngInject*/
function yesNoFilter(gettextCatalog) {
    return function (input) {
        return input ? gettextCatalog.getString('yes') : gettextCatalog.getString('no');
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/filters/yesNoFilter.js
// module id = 726
// module chunks = 0